import { AccessDeniedError } from "../../../domain/errors";
import { UnauthorizedError } from "../../../domain/errors/unauthorized-error";
import { useLogout } from "./use-logout";

type CallBackType = (error: Error) => void;
type ResultType = CallBackType;

export const useErrorHandler = (callback: CallBackType): ResultType => {
  const logout = useLogout();
  return (error: Error): void => {
    if (
      error instanceof AccessDeniedError ||
      error instanceof UnauthorizedError
    ) {
      logout();
    } else {
      callback(error);
    }
  };
};
